import { InfoPage } from "./info";

export const Info = InfoPage;
